import { Effect, Reducer, Subscription } from 'umi';
import {
  getGameConfig,
  getSelector,
  getLatestDate,
  getSelectorSchemeList,
} from '@/pages/dashboard/services/dashboardSetting';
import { GameConfigType, LatestDateType, LatestDateItemType } from '@/pages/dashboard/types/dashboard';
import { formatSortFiltersData } from '@/pages/dashboard/utils/_config/formatSortFiltersData';
import { getNameMap, getSelectorMap } from '../_config/filterListMap';

import { testData } from './filterConfigTestData'
import { formatSeasonInfo } from './_config/_utils';
import { formatOptions, handleOutFilterKey } from '../components/NewFilter/util';
import { LANGUAGE_CN } from '@/pages/dashboard/_config/constant';

//Platform 图标
import Default from '@/pages/home/assets/svg/dashboard/default.svg';
import { getSystemFlag } from '@/pages/dashboard/pages/overview/_config/system';
import { getMediaChannelIcon, mediaChannelMap } from '@/pages/home/_config/mediaChannal';
import { START_OF_DATE } from '../utils/_config/constant';
import { DURATION_TYPE_VALUE } from '../components/NewFilter/_config';
import { getOpinionPermissions } from '../services/dashboard';
export const namespace = 'dashboardSetting';
export interface DashboardSettingModelStateType {
  gameConfig: null | GameConfigType; // 游戏配置
  selector: any;
  selectorMap: any;
  uaSelectorMap: any,
  latestDate: LatestDateType;
  selectorSchemeList: any
  selectedfilterDuration: any
  filterDurationData:any
}

export interface DashboardSettingModelType {
  namespace: string;
  state: DashboardSettingModelStateType;
  effects: {
    getGameConfig: Effect;
    getSelector: Effect;
    getUaSelectorMap: Effect;
    getLatestDate: Effect;
    getSelectorSchemeList: Effect;
    setFilterSaveDuration: Effect;
    setFilterSaveDurationDate: Effect;
  };
  reducers: {
    save: Reducer<DashboardSettingModelStateType>;
    // 启用 immer 之后
    // save: ImmerReducer<IndexModelState>;
  };
  // subscriptions: { setup: Subscription };
}

const DashboardSettingModel: DashboardSettingModelType = {
  namespace: namespace,

  state: {
    gameConfig: null,
    selector: null,
    selectorMap: null,
    uaSelectorMap: null,
    latestDate: {
      gameCode: ''
    },
    selectorSchemeList: null,
    selectedfilterDuration: null,
    filterDurationData:DURATION_TYPE_VALUE,
  },

  effects: {
    // 获取业务配置
    // 在 *getGameConfig 函数中
    *getGameConfig({ payload }, { put }) {
      const { gameCode } = payload;
      try {
        const result: GameConfigType = yield getGameConfig(gameCode) || {};
        const seasonInfoResult = formatSeasonInfo(result?.season_info || { day: [], week: [], month: [] })
        yield put({
          type: "save",
          payload: {
            gameConfig: { ...result, season_info: seasonInfoResult }
          }
        });
        // 获取舆情权限
        const permission: {
          list: { edition_unified_id: string; opinion_permissions: boolean }[];
        } = yield getOpinionPermissions({
          edition_unified_ids: [result?.unifiedid],
        });

        if (permission?.list && permission.list?.length > 0) {
          yield put({
            type: 'save',
            payload: {
              gameConfig: {
                ...result, season_info: seasonInfoResult,
                hasOpinionPermissions: permission.list[0]?.opinion_permissions || false,
                unifiedid: result?.unifiedid
              }
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取筛选器下拉数据
    *getSelector({ payload }, { put }) {
      const { gameCode, dataFrame } = payload;
      try {
        const result: any = yield getSelector(gameCode);
        let resultData = formatSortFiltersData(result || {});
        if (dataFrame === 'pc') {
          resultData.os_list = resultData?.os_list?.map((item: any) => {
            const cleanedEnKey = item.os_name_en.toLowerCase().replace(/\s+/g, '');
            item.icon = getSystemFlag(cleanedEnKey) || Default
            return item;
          });
        }
        if (resultData?.ua_network) {
          resultData.ua_network = resultData.ua_network.map((item: any) => {
            const channelIcon = getMediaChannelIcon(item.name_en || item.code || '');
            item.icon = channelIcon === mediaChannelMap._default ? Default : channelIcon;
            return item;
          });
        }

        const selectorData = { ...(resultData || {}), gameCode };
        yield put({
          type: "save",
          payload: {
            selector: selectorData,
            selectorMap: getSelectorMap(selectorData)
          }
        });
      } catch (error) {
        console.log(error)
      }
    },

    // 获取游戏时区
    *getUaSelectorMap({ payload }, { put }) {
      yield put({
        type: "save",
        payload: {
          uaSelector: payload?.uaSelector,
          uaSelectorMap: getNameMap(payload?.gameCode),
        }
      });
    },         

    // 获取最近有数据的时间
    *getLatestDate({ payload }, { put, select }) {
      const { gameCode, type = 'dau' } = payload;
      try {
        const result: LatestDateItemType = yield getLatestDate(gameCode, type);
        const { latestDate } = yield select((state: any) => state[namespace]);
        let data: LatestDateType = { gameCode };
        if (latestDate.gameCode === gameCode) {
          data = {
            ...latestDate,
            [type]: result
          }
        } else {
          data = {
            ...data,
            [type]: result
          }
        }
        yield put({
          type: "save",
          payload: {
            latestDate: data
          }
        });
      } catch (error) {
        console.log(error)
      }
    },

    // 获取筛选器方案
    *getSelectorSchemeList({ payload }, { put }) {
      const { gameCode } = payload;
      try {
        let result: any = yield getSelectorSchemeList(gameCode);
        result = result?.map((item:any)=>{
          return {
            ...item,
            filter_cond:{
              ...(item?.filter_cond || {}),
              // 把后端返回的下划线命名转为驼峰命名
              ext_filter: handleOutFilterKey(item?.filter_cond?.ext_filter || {})
            }
          }
        }) || []
        yield put({
          type: "save",
          payload: {
            selectorSchemeList: result || []
          }
        });
      } catch (error) {
        console.log(error)
      }

    },
    *setFilterSaveDuration({ payload }, { put }) {
      yield put({
        type: "save",
        payload: {
          selectedfilterDuration: payload?.data,
        }
      });
    },
    *setFilterSaveDurationDate({ payload }, { put }) {
      yield put({
        type: "save",
        payload: {
          filterDurationData: payload?.data,
        }
      });
    }
  },
  reducers: {
    save(state: DashboardSettingModelType, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
  }
};

export default DashboardSettingModel;
